
/**
 * 写cookies
 */
export function setCookie (name, value, time) {
  const domain = window.sessionStorage.getItem('domain');
  const TokenKey = window.sessionStorage.getItem('TokenKey');
  const CookieDay = sessionStorage.getItem('cookieDay') || 7;
  if (!time) {
    time = new Date().getTime() + CookieDay * 1000 * 24 * 60 * 60;
  } else {
    time = time + CookieDay * 1000 * 24 * 60 * 60;
  }
  let exp = new Date(time);
  document.cookie = (name || TokenKey) + "=" + value + "; domain="+domain+"; path=/;expires=" + exp.toGMTString();
}

/**
 * 读取cookies
 */
export function getCookie (name,val=null) {
  const TokenKey = window.sessionStorage.getItem('TokenKey');
  let arr, reg = new RegExp("(^| )" + (name || TokenKey) + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))&&!val) {
    return unescape(arr[2]);
  }else if((arr = document.cookie.match(reg))&&val){
    return arr[2];
  } else {
    return '';
  }
}

/**
 * 删除cookies
 */
export function delCookie (name) {
  const domain = window.sessionStorage.getItem('domain');
  const TokenKey = window.sessionStorage.getItem('TokenKey');
  let cookieValue = getCookie(name);
  if (cookieValue != null) {
    document.cookie = (name || TokenKey) + "=null;domain="+domain+"; path=/;expires=" + new Date().toGMTString();
  }
}

export function deleteAllCookie () {
  let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (let i = 0; i < keys.length; i++) {
      if(keys[i].toUpperCase().indexOf('WWW') > -1) {
        delCookie(keys[i]);
      }
    }
  }
}

/**
 * 返回顶部
 */
export function scrollTop(el, from = 0, to, duration = 500, endCallback) {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000/60);
      }
    );
  }
  const difference = Math.abs(from - to);
  const step = Math.ceil(difference / duration * 50);

  function scroll(start, end, step) {
    if (start === end) {
      endCallback && endCallback();
      return;
    }

    let d = (start + step > end) ? end : start + step;
    if (start > end) {
      d = (start - step < end) ? end : start - step;
    }

    if (el === window) {
      window.scrollTo(d, d);
    } else {
      el.scrollTop = d;
    }
    window.requestAnimationFrame(() => scroll(d, end, step));
  }
  scroll(from, to, step);
}

/**
 * 手机号码正则
 */
export function isPhone (num) {
  let phone = Number(num);
  if (phone) {
    let reg = /^1[34578]\d{9}$/;
    return reg.test(phone);
  } else {
    return false
  }
}

export function isTel (num) {
  let tel = Number(num);
  if (tel) {
    let reg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
    return reg.test(tel);
  } else {
    return false
  }
}

/**
 * 邮箱正则
 */
export function isEmail (email) {
  let reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
  return reg.test(email)
}

/**
 * 8-16位密码正则
 */
export function isPsw (psw) {
  let reg = /(?=.*[a-zA-Z])(?=.*\d)(?=.*[#@!?$~%^&*])[a-z\d#@!.~%^&*]{8,16}/i;
  return reg.test(psw)
}
export function isPassword(password) {
  let reg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,16}$/;
  return reg.test(password);
}

//货币格式转换
export function formatCurrency(num) {
  if(!num)return '';
  num = num.toString().replace(/\$|\,/g,'');
  if(isNaN(num))
      num = "0";
  let sign = (num == (num = Math.abs(num)));
  num = Math.floor(num*100+0.50000000001);
  let cents = num%100;
  num = Math.floor(num/100).toString();
  if(cents<10)
  cents = "0" + cents;
  for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
  num = num.substring(0,num.length-(4*i+3))+','+
  num.substring(num.length-(4*i+3));
  return (((sign)?'':'-') + num + '.' + cents);
}



// WEBPACK FOOTER //
// ./src/common/js/v.js